import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getBrandsAPI,
  createBrandAPI,
  deleteBrandsAPI,
  UpdateReceiptColorAPI,
  updateBrandDefaultSettingsAPI,
} from "api/brandApi";
import { get } from "lodash";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  brandsList: [],
  totalBrands: 0,
  loading: false,
  creatingBrand: false,
  brandCreated: false,
  error: null,
};

export const createBrand = createAsyncThunk(
  "brand/createBrand",
  async (brandData, { rejectWithValue }) => {
    try {
      const response = await createBrandAPI(brandData);
      return response.data; // Assuming API returns some data upon success
    } catch (error) {
      return handleThunkError(error, rejectWithValue); // Returning error message using rejectWithValue
    }
  }
);

export const getBrands = createAsyncThunk(
  "brand/getBrands",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBrandsAPI();
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const deleteBrand = createAsyncThunk(
  "brand/deleteBrand",
  async (data, { rejectWithValue }) => {
    try {
      const response = await deleteBrandsAPI(data);
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const updateReceiptColor = createAsyncThunk(
  "brand/updateReceiptColor",
  async (data, { rejectWithValue }) => {
    try {
      const response = await UpdateReceiptColorAPI(data);
      return response.data;
    } catch (error) {
      console.log("update color error ======>", error);
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const updateBrandDefaultSettings = createAsyncThunk(
  "brand/updateBrand",
  async (brandData, { rejectWithValue }) => {
    try {
      const response = await updateBrandDefaultSettingsAPI(brandData);
      return response.data; // Assuming API returns some data upon success
    } catch (error) {
      return handleThunkError(error, rejectWithValue); // Returning error message using rejectWithValue
    }
  }
);

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    resetBrandState: (state) => {
      state.creatingBrand = false;
      state.brandCreated = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBrand.pending, (state) => {
        state.creatingBrand = true;
        state.brandCreated = false;
        state.error = null;
      })
      .addCase(createBrand.fulfilled, (state) => {
        state.creatingBrand = false;
        state.brandCreated = true;
        state.error = null;
      })
      .addCase(createBrand.rejected, (state, action) => {
        state.creatingBrand = false;
        state.brandCreated = false;
        state.error = action.payload; // Storing error message if available
      })
      .addCase(getBrands.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBrands.fulfilled, (state, { payload }) => {
        state.brandsList = get(payload, "brands", []);
        state.totalBrands = get(payload, "total", 0);
        state.loading = false;
      })
      .addCase(getBrands.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetBrandState } = brandSlice.actions;
export default brandSlice.reducer;
